import axios from "axios";
import { isPrivacy, maskAmount } from "@/lib/privacy";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (v) => {
  const s = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(v || 0));
  return isPrivacy() ? maskAmount(s) : s;   // solo mascheramento visivo: il valore reale non cambia
};

export const mesi = [
  "", "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export const priorityColors = {
  bassa: "bg-slate-100 text-slate-700 border-slate-200",
  media: "bg-sky-100 text-sky-800 border-sky-200",
  alta: "bg-amber-100 text-amber-800 border-amber-200",
  urgente: "bg-rose-100 text-rose-800 border-rose-200",
};

export const statusColors = {
  bozza: "bg-amber-100 text-amber-800 border-amber-200",
  controllato: "bg-blue-100 text-blue-800 border-blue-200",
  inviato: "bg-indigo-100 text-indigo-800 border-indigo-200",
  pagato: "bg-emerald-100 text-emerald-800 border-emerald-200",
  da_fare: "bg-slate-100 text-slate-700 border-slate-200",
  programmata: "bg-sky-100 text-sky-800 border-sky-200",
  in_corso: "bg-sky-100 text-sky-800 border-sky-200",
  completata: "bg-emerald-100 text-emerald-800 border-emerald-200",
  completato: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export const sourceLabels = {
  pulizia: "Pulizia", lavanderia: "Lavanderia", consumabile: "Consumabile",
  manutenzione: "Manutenzione", uscita: "Uscita", manuale: "Manuale",
};

export const docCategories = [
  "Fattura lavanderia", "Fattura pulizie", "Manutenzione",
  "Consumabili", "Amenities", "Documento proprietario", "Altro",
];

export const consumableCategories = [
  "Consumabili", "Prodotti pulizia", "Carta igienica", "Caffè",
  "Tè", "Caramelle", "Amenities", "Altro",
];

export const laundryLabels = {
  double_sheets: "Lenzuola matrimoniali",
  single_sheets: "Lenzuola singole",
  pillowcases: "Federe",
  large_towels: "Asciugamani grandi",
  medium_towels: "Asciugamani medi",
  bath_mats: "Tappeti bagno",
};

export const laundryKeys = Object.keys(laundryLabels);

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return iso; }
}

export function fileUrl(fid) {
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${fid}/download`;
}
